import Logo from '../img/logo.png';
export const bgWhite = '#f7f7f7'; // Used for View More Button Line
export const Green = '#4CAF50'; // Used for the Offer checkmark when email is shared and for the commission checkmark when a commission is paid
export const Black = 'rgba(0, 0, 0, 0.87)';
export const LightGray = '#BDBDBD'; //Used for the address bar when unHovered on Offers
export const Accent = '#ff4081'; //Used for the landing page cta button pinkish
export const Primary = '#3f51b5'; //Used for the View Archived text
export const Purple = 'rgb(146, 113, 246)';
export const PurpleShadow = 'rgba(146, 113, 246,0.2)'; //Used for the landing page card shadows
export const LightPurple = 'rgba(225,215,255,1)'; //The colour of the ribbon lightpurple on the homepage

export const Title = window.location.hostname.split('.')[0].toUpperCase();

export const Industries = [
	'Airlines/Aviation',
	'Apparel & Fashion',
	'Architecture & Planning',
	'Automotive',
	'Aviation & Aerospace',
	'Banking',
	'Biotechnology',
	'Broadcast Media',
	'Building Materials',
	'Business Supplies and Equipment',
	'Capital Markets',
	'Chemicals',
	'Commercial Real Estate',
	'Computer & Network Security',
	'Computer Games',
	'Computer Hardware',
	'Computer Networking',
	'Computer Software',
	'Construction',
	'Consumer Goods',
	'Consumer Services',
	'Cosmetics',
	'Defense & Space',
	'Education',
	'Engineering',
	'Entertainment',
	'Environmental Services',
	'Events Services',
	'Executive Search',
	'Facilities Services',
	'Farming',
	'Financial Services',
	'Food & Beverages',
	'Food Production',
	'Gambling & Casinos',
	'Government Administration',
	'Government Relations',
	'Health, Wellness and Fitness',
	'Higher Education',
	'Hospital & Health Care',
	'Hospitality',
	'Individual & Family Services',
	'Industrial Automation',
	'Information Technology and Services',
	'Insurance',
	'International Affairs',
	'International Trade and Development',
	'Investment Banking',
	'Law Enforcement',
	'Law Practice',
	'Legal Services',
	'Leisure, Travel & Tourism',
	'Libraries',
	'Logistics and Supply Chain',
	'Luxury Goods & Jewelry',
	'Machinery',
	'Management Consulting',
	'Market Research',
	'Marketing and Advertising',
	'Media Production',
	'Medical Devices',
	'Medical Practice',
	'Mental Health Care',
	'Military',
	'Mining & Metals',
	'Motion Pictures and Film',
	'Museums and Institutions',
	'Music',
	'Non-Profit Organization Management',
	'Oil & Energy',
	'Online Media',
	'Paper & Forest Products',
	'Performing Arts',
	'Pharmaceuticals',
	'Photography',
	'Plastics',
	'Printing',
	'Professional Training & Coaching',
	'Program Development',
	'Public Relations and Communications',
	'Public Safety',
	'Publishing',
	'Railroad Manufacture',
	'Real Estate',
	'Recreational Facilities and Services',
	'Religious Institutions',
	'Renewables & Environment',
	'Research',
	'Restaurants',
	'Retail',
	'Security and Investigations',
	'Social Work',
	'Sporting Goods',
	'Sports',
	'Staffing and Recruiting',
	'Telecommunications',
	'Textiles',
	'Tobacco',
	'Translation and Localization',
	'Transportation/Trucking/Railroad',
	'Utilities',
	'Venture Capital & Private Equity',
	'Veterinary',
	'Warehousing',
	'Wine and Spirits',
	'Wireless'
];

export const Functions = [
	'Accounting',
	'Administrative',
	'Arts and Design',
	'Consultant',
	'Educator',
	'Engineer',
	'Entrepreneur',
	'Finance',
	'Healthcare Services',
	'Human Resources',
	'Information Technology',
	'Legal',
	'Marketing',
	'Media & Communications',
	'Military & Protective Services',
	'Operations',
	'Product Management',
	'Program Management',
	'Purchasing',
	'Quality Assurance',
	'Real Estate',
	'Research',
	'Sales',
	'Social Worker',
	'Software Developer'
];

export const handler = window.StripeCheckout.configure({
	key: 'pk_test_v2TzNljZwdJG6mw53JiRpxwu',
	image: Logo,
	locale: 'auto',
	token: token => {
		console.log(token);
	}
});



// WEBPACK FOOTER //
// ./src/helper/consts.js